import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './OrderEditScreen';
import OrderEdit from './OrderEditScreen';
import { StoreState } from 'src/store/reducers';
import {
    getOrder,
    deleteFileOrder,
    getFiles,
    createFilesInOrder,
    asyncCreateFilesOrder,
} from 'src/store/actions/order-actions';
import { formValueSelector } from 'redux-form';
import { getStudents } from '../../../../../../store/actions/student-actions';
import { QueryParams } from '../../../../../../types/grid';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';
import { toast } from 'react-toastify';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('order-form');
    const params = selector(state, 'orderTypeDropDown');
    const statusItem = selector(state, 'statusDropDown');

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const statusEnum = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(statusEnum);

    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const orderTypeValue: string | number = params ? params.value : orderTypes ? orderTypes[0].value : 1;

    const statusItemValue: string | number = statusItem ? statusItem.value : statusItems ? statusItems[0].value : 1;

    return {
        order: state.orders.current,
        inProgress: state.orders.inProgress,
        files: state.orders.currentFiles,
        orderTypeValue,
        serviceTypesOrder: state.serviceTypes.data,
        statusItemValue,
        orderTypes,
        students: selectNameStudents(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getOrder(id)),
        getStudentsAct: (params: QueryParams) => dispatch(getStudents(params)),
        getOrderServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: async (id, files) => await asyncCreateFilesOrder(id, files, dispatch),
        addFilesOrder: (id, files) =>
            dispatch(
                createFilesInOrder(
                    id,
                    files,
                    () => toast.success('Order File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        removeFile: (id) => dispatch(deleteFileOrder(id)),
    };
}

const OrderEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderEdit);

export default OrderEditScreen;
